const config = window.RUNTIME_CONFIG || {};

export const FRONTEND_WEBCAPTIONER_SERVER                 = config.FRONTEND_WEBCAPTIONER_SERVER;
export const FRONTEND_YOUTUBE_REGION                      = config.FRONTEND_YOUTUBE_REGION;
export const FRONTEND_DEFAULT_SOTRA_MODEL                 = config.FRONTEND_DEFAULT_SOTRA_MODEL;
export const FRONTEND_DEFAULT_YOUTUBE_TIME_OFFSET         = config.FRONTEND_DEFAULT_YOUTUBE_TIME_OFFSET;
export const FRONTEND_MAX_LINES_IN_HISTORY                = config.FRONTEND_MAX_LINES_IN_HISTORY;
export const FRONTEND_DEFAULT_VOSK_SAMPLE_RATE            = config.FRONTEND_DEFAULT_VOSK_SAMPLE_RATE;
export const FRONTEND_RECORDING_INFORMATION_LINE          = config.FRONTEND_RECORDING_INFORMATION_LINE;
export const FRONTEND_DEFAULT_AUDIO_FORMAT                = config.FRONTEND_DEFAULT_AUDIO_FORMAT;
export const FRONTEND_SEND_TIMESTAMP                      = config.FRONTEND_SEND_TIMESTAMP;
export const FRONTEND_SEND_TIMESTAMP_COUNT                = config.FRONTEND_SEND_TIMESTAMP_COUNT;
export const FRONTEND_DEFAULT_TRANSLATION_TARGET_LANGUAGE = config.FRONTEND_DEFAULT_TRANSLATION_TARGET_LANGUAGE;
